import { render, staticRenderFns } from "./Ses.vue?vue&type=template&id=5406abfe&scoped=true"
import script from "./Ses.vue?vue&type=script&lang=js"
export * from "./Ses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5406abfe",
  null
  
)

export default component.exports